import { Middleware, Dispatch } from 'redux';
import { getType } from 'typesafe-actions';
import { FeedActions } from '../actions';
import Config from '../../../config';

export const perfQuotesMiddleware: Middleware = () => (next: Dispatch<any>) => action => {
  if (action && action.type === getType(FeedActions.updateQuotes)) {
    if (!Config.isProduction && typeof performance !== 'undefined' && performance.mark) {
      performance.mark('quotes-dispatch-start');
    }
    const result = next(action);
    if (!Config.isProduction && typeof performance !== 'undefined' && performance.measure) {
      try {
        performance.measure('quotes-dispatch', 'quotes-dispatch-start');
      } catch {}
    }
    return result;
  }
  return next(action);
};
